import apiFetch from '../apiFetch'

export default function (userId = 0, token) {
  return apiFetch({ endPoint: 'user/' + userId, method: 'DELETE', body: null, token: token })
}
